import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Button from 'react-bootstrap/lib/Button';

import t from '../../lib/I18n';

import ConfirmModal from '../general/ConfirmModal';
import ModalTabs from '../general/ModalTabs';
import Icon from '../general/Icon';

class RegisterModalHeader extends React.PureComponent {
    state = {
        isConfirmVisible: false
    };

    filteredSteps = [];

    componentDidMount() {
        this.filteredSteps = this.getFilteredSteps();
    }

    getFilteredSteps = () => {
        const { steps, hideSteps } = this.props;
        return Object.entries(steps)
            .filter(([stepName]) => !hideSteps.includes(stepName));
    };

    handleContinueLoginTab = () => {
        const { handleLogin, onClose } = this.props;

        onClose({ canRedirect: false });
        handleLogin();
    };

    getPreviousStepDetails = () => {
        const {step} = this.props;
        const filteredSteps = this.filteredSteps;
        const currentStepIndex = filteredSteps.findIndex(i => i[1] === step);
        return filteredSteps[currentStepIndex - 1];
    };

    getPreviousStepName = () => {
        return this.getPreviousStepDetails()[0];
    };

    getPreviousStepNumber = () => {
        return this.getPreviousStepDetails()[1];
    };

    handleStep = () => {
        const {handleStepBack} = this.props;
        const prevStepNumber = this.getPreviousStepNumber();

        handleStepBack(prevStepNumber);
    };

    isFirstStep = () => {
       return !this.getPreviousStepDetails();
    };

    toggleModal = () =>
        this.setState(state => ({ isConfirmVisible: !state.isConfirmVisible }));

    render() {
        const {
            hideClose,
            onClose,
            dictionaryPrefix
        } = this.props;
        const {
            isConfirmVisible
        } = this.state;

        return (
            <React.Fragment>
                <ConfirmModal
                    className="modal--sm modal--small-confirm"
                    closeText="No, go back"
                    continueText="Yes, close the form"
                    onClose={ this.toggleModal }
                    onContinue={ onClose }
                    header={ false }
                    show={ isConfirmVisible }
                    text= { t('account.register.closeConfirm') }
                />
                {this.isFirstStep() ? (
                    <ModalTabs activeTab="register">
                    <ModalTabs.Tab name="register" title={ t('account.register') } />
                    <ModalTabs.Tab name="login" onClick={ this.handleContinueLoginTab } title={ t('account.login') } />
                </ModalTabs>
                ) : (
                    <div className="modal__header--go-back" onClick={this.handleStep}>
                        <Icon icon="chevronslim" />
                        {t(`${dictionaryPrefix}${this.getPreviousStepName().toLowerCase()}`)}
                    </div>
                )}

                {!hideClose && (
                    <Button
                        className="btn btn-link modal-header__close-button"
                        data-test-id="register-modal-header-close-button"
                        onClick={this.toggleModal}
                    >
                        <Icon icon="close" srOnly={t('button.text.close')} />
                    </Button>
                )}
            </React.Fragment>
        );
    }
}

RegisterModalHeader.propTypes = {
    handleLogin: PropTypes.func,
    isFormDirty: PropTypes.bool,
    hideClose: PropTypes.bool,
    onClose: PropTypes.func,
    showExtraOptions: PropTypes.bool,
    step: PropTypes.object,
    steps: PropTypes.object,
    hideSteps: PropTypes.object,
    handleStepBack: PropTypes.func,
    dictionaryPrefix: PropTypes.string
};

RegisterModalHeader.defaultProps = {
    handleLogin: _.noop,
    isFormDirty: false,
    hideClose: false,
    onClose: _.noop,
    showExtraOptions: false,
    step: {},
    steps: {},
    hideSteps: [],
    handleStepBack: _.noop,
    dictionaryPrefix: ''
};

export default RegisterModalHeader;
